// extracted by mini-css-extract-plugin
export default {"speakerBox":"ButtonAudio_speakerBox__huIH1","audioBtn":"ButtonAudio_audioBtn__sDev8","icoSpeaker":"ButtonAudio_icoSpeaker__gB5hv","soundLottie":"ButtonAudio_soundLottie__JeUOQ"};